
import Vue, { PropType } from "vue";
import { Website } from "@/models";
import BaseDropDown, { OptionItem } from "@/components/BaseDropDown.vue";

export type DataType = {
  options: OptionItem[];
  showing: boolean;
};

export default Vue.extend({
  name: "WebsiteListItem",

  components: {
    BaseDropDown,
  },

  props: {
    website: Object as PropType<Website>,
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },

    passcodeText(): string {
      return this.website.passcode || "-";
    },

    memo(): string {
      return this.website.memo || "";
    },

    idpassText(): string {
      return this.website.useTenantIdPass ? "必要" : "不要";
    },

    urlText(): string {
      return this.website.url || "";
    },

    editMenuClassText(): string {
      return this.showing ? "active" : "";
    },
  },

  data(): DataType {
    return {
      options: [
        {
          label: "サービスURL編集",
          classes: [],
          clickAction: () => {
            this.$router.push({
              name: "company-website-detail",
              params: {
                websiteId: this.website.id as string,
              },
            });
          },
        },
        {
          label: "サービスURL削除",
          classes: ["red"],
          disabled: this.$auth.role === "admin" ? false : true,
          clickAction: () => {
            this.$router.push({
              name: "company-website-delete",
              params: {
                websiteId: this.website.id as string,
              },
            });
          },
        },
        {
          label: "エリア管理",
          classes: [],
          clickAction: () => {
            this.$router.push({
              name: "company-website-public-places",
              params: {
                websiteId: this.website.id as string,
              },
            });
          },
        },
      ],

      showing: false,
    };
  },
});
